import React, { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../style/AddEventModal.css";

const AddJobModal = ({ isOpen, onClose, onAddEvent, customTags }) => {
  if (!isOpen) return null;

  // Use refs instead of useState
  const titleRef = useRef();
  const dateRef = useRef();
  const timeRef = useRef();
  const jobPositionRef = useRef();
  const locationRef = useRef();
  const descriptionRef = useRef();
  const linkRef = useRef();
  const [jobCategory, setJobCategory] = React.useState("saved_jobs");

  const handleSubmitlink = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload

    const title = titleRef.current.value.trim();
    const job_date = dateRef.current.value || null;
    const job_time = timeRef.current.value || null;
    const job_position = jobPositionRef.current.value.trim();
    const location = locationRef.current.value.trim();
    const description = descriptionRef.current.value.trim();
    const link = linkRef.current.value.trim();
    const job_category = jobCategory;

    // Validate job link is not empty
    if (!link) {
      alert("Job link cannot be empty.");
      return;
    }

    // Validate title length before submitting
    if (title.length < 3 || title.length > 255) {
      alert("Title must be between 3 and 255 characters.");
      return;
    }

    if (!title) {
      alert("Company Name is required.");
      return;
    }
    console.log("Form Data:", {
      title,
      job_date,
      job_time,
      job_position,
      location,
      description,
      link,
      job_category,
    });

    // Pass event data to parent component
    onAddEvent({
      title,
      job_date,
      job_time,
      job_position,
      location,
      description,
      link,
      job_category,
    });

    onClose(); // Close modal after submission
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>New Job Details</h2>
          <CloseIcon className="close-icon" onClick={onClose} />
        </div>

        <input
          type="url"
          ref={linkRef}
          onChange={handleSubmitlink}
          placeholder="Job link: https://example.com"
          className="modal-input"
          required
        />

        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="text"
            ref={titleRef}
            placeholder="Company Name"
            className="modal-input"
            required
          />

          <input
            type="text"
            ref={jobPositionRef}
            placeholder="Position"
            className="modal-input"
            required
          />

          <div className="modal-date-time">
            <input type="date" ref={dateRef} className="modal-input" />
            <input type="time" ref={timeRef} className="modal-input" />
          </div>

          <input
            type="text"
            ref={locationRef}
            placeholder="Location"
            className="modal-input"
          />

          <textarea
            ref={descriptionRef}
            placeholder="Job Description"
            className="modal-textarea"
          ></textarea>

          <select
            name="job_category"
            className="modal-input"
            value={jobCategory}
            onChange={(e) => setJobCategory(e.target.value)}
          >
            <option value="saved_jobs">Saved Jobs</option>
            <option value="applied">Applied</option>
            <option value="interview">Interview</option>
            <option value="offered">Offered</option>
            {customTags.map((tag) => (
              <option key={tag.id} value={tag.name}>
                {tag.name}
              </option>
            ))}
          </select>

          <button type="submit" className="modal-button">
            Add Job
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddJobModal;
